import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";

export default function TerminiPage() {
  useEffect(() => { document.title = "Tavoli da Gioco — Termini di Servizio"; }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7] dark:bg-[#181818]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#2B593F] dark:text-[#8FC79F] hover:underline mb-6"
        >
          <ArrowLeft size={14} /> Torna al dashboard
        </Link>

        <h1 className="font-display text-3xl font-bold text-[#2D2A26] dark:text-[#F5F1EA] tracking-tight mb-2">Termini di Servizio</h1>
        <p className="text-sm text-[#757169] dark:text-[#B8B2AA] dark:text-[#B8B2AA] mb-8">Ultimo aggiornamento: maggio 2025</p>

        <div className="bg-white dark:bg-[#111111] border border-[#EAE3D9] dark:border-[#2A2A2A] rounded-2xl p-6 sm:p-8 space-y-6 text-sm text-[#4A4742] dark:text-[#C8C2BA] leading-relaxed">

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">1. Il servizio</h2>
            <p>
              <strong>Tavoli da Gioco</strong> è una piattaforma comunitaria che consente agli utenti
              registrati di organizzare e prenotare tavoli da gioco presso le sedi convenzionate
              (Bibliocronache, Patrogames). Il servizio è gratuito e riservato ai membri della community.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">2. Registrazione e account</h2>
            <p>
              Per utilizzare il servizio è necessario registrarsi con un indirizzo email valido e
              scegliere un username univoco. L'utente è responsabile della riservatezza delle
              proprie credenziali e di tutte le attività effettuate con il proprio account.
            </p>
            <p className="mt-2">
              È vietato creare account falsi, impersonare altre persone o utilizzare username
              offensivi o inappropriati.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">3. Utilizzo corretto</h2>
            <p>Gli utenti si impegnano a:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-[#757169] dark:text-[#B8B2AA]">
              <li>Usare la piattaforma in buona fede e nel rispetto degli altri utenti</li>
              <li>Non creare tavoli fittizi o abusare del sistema di prenotazione</li>
              <li>Presentarsi ai tavoli prenotati o annullare la propria iscrizione per tempo</li>
              <li>Non utilizzare il servizio per scopi commerciali o pubblicitari</li>
            </ul>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">4. Contenuti degli utenti</h2>
            <p>
              Gli utenti sono responsabili dei contenuti che pubblicano (nomi dei tavoli, descrizioni,
              giochi). Il team di Tavoli da Gioco si riserva il diritto di rimuovere contenuti
              inappropriati e di sospendere account che violino queste regole.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">5. Disponibilità del servizio</h2>
            <p>
              Il servizio è fornito "così com'è", senza garanzie di disponibilità continua.
              I tavoli vengono azzerati periodicamente (ogni mercoledì per Bibliocronache,
              ogni sabato per Patrogames) — pianifica di conseguenza.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">6. Limitazione di responsabilità</h2>
            <p>
              Tavoli da Gioco non è responsabile per eventuali disservizi, perdita di dati o
              danni derivanti dall'utilizzo della piattaforma. La partecipazione agli eventi
              organizzati tramite il servizio avviene sotto la responsabilità esclusiva degli utenti.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">7. Modifiche ai termini</h2>
            <p>
              Ci riserviamo di modificare questi termini in qualsiasi momento. Le modifiche
              sostanziali saranno comunicate tramite avviso in app o email con almeno 7 giorni
              di preavviso. L'utilizzo continuato del servizio costituisce accettazione dei nuovi termini.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">8. Contatti</h2>
            <p>
              Per qualsiasi domanda scrivi a{" "}
              <a href="mailto:info@tavolidagioco.eu" className="text-[#2B593F] hover:underline">info@tavolidagioco.eu</a>.
            </p>
          </section>

        </div>
      </main>
    </div>
  );
}
